import { pdfRender } from "./pdfRender";
import { uiRender } from "./uiRender";
import { propPanel } from "./propPanel";
const schema = {
    pdf: pdfRender,
    ui: uiRender,
    propPanel,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-line"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="m19 9-5 5-4-4-3 3"/></svg>',
    uninterruptedEditMode: true
};
export default schema;
//# sourceMappingURL=index.js.map